module.exports = __webpack_public_path__ + "static/media/promotions.04fee637.png";